import React, { useContext } from "react";
import {
  Box,
  Grid,
  InputAdornment,
  // Autocomplete,
  // FormLabel,
} from "@mui/material";
import { BiEdit } from "react-icons/bi";
import { MdLocationOn } from "react-icons/md";
import LabelWithTooltip from "../LabelWithTooltip/LabelWithTooltip";
import {
  eventInfoStyles as classes,
  eventInfoCustomStyle as customStyle,
} from "../../pages/EventInfo/styles";
import { Controller } from "react-hook-form";
import { DateTimePicker } from "@mui/x-date-pickers";
import moment from "moment-timezone";
import FdTextField from "../UIComponents/TextField/FdTextfield";
import { UseFormRegister } from "react-hook-form";
import FdAutoComplete from "../UIComponents/AutoComplete/FdAutoComplete";
import FdSwitch from "../UIComponents/Switch/FdSwitch";
import FdTypography from "../UIComponents/Typography/FdTypography";
import { useHasPermissions } from "../../hooks/useHasPermissions";
import { PERMISSIONS } from "../../roles";

interface IEventFormNew {
  register: UseFormRegister<any>;
  selectedEvent: any;
  control: any;
  getValues: any;
  errors: any;
  isEventInfo: boolean;
  isLead?: boolean;
}
export const EventFormNew = (props: IEventFormNew) => {
  const { selectedEvent, register, control, getValues, errors, isEventInfo, isLead } =
    props;
  const canManageLeads = useHasPermissions(PERMISSIONS.CAN_MANAGE_LEADS);
  const [checked, setChecked] = React.useState(isLead);
  const getTimezoneLabels = () => {
    const tznames = moment.tz.names();
    return tznames.map((tzname) => {
      return { label: tzname, value: tzname };
    });
  };
  const timezoneLabels = getTimezoneLabels();
  const disablePast = true;
  const htmlRegex = /[<>]/;
  return (
    <>
      <Box>
        <Box sx={classes.allFields}>
          <Grid container spacing={3}>
            <Grid item xs={!isEventInfo ? 12 : 6}>
              <Controller
                name="eventName"
                control={control}
                rules={{
                  required: 'Event Name is required',
                  validate: (value) => !htmlRegex.test(value) || 'HTML tags are not allowed'
                }}
                render={({ field }) => (
                  <FdTextField
                    {...field}
                    required
                    name="eventName"
                    id="eventName"
                    label="Event Name"
                    InputProps={{
                      sx: classes.textFieldWithAdornment,
                      endAdornment: (
                        <InputAdornment position="end" sx={classes.inputIcon}>
                          <BiEdit />
                        </InputAdornment>
                      ),
                    }}
                    error={!!errors.eventName}
                    errorMsg={errors.eventName ? errors.eventName.message : ''}
                  />)} />
            </Grid>
            <Grid item xs={!isEventInfo ? 12 : 6}>
              <Grid container spacing={3}>
                <Grid item xs={!isEventInfo ? 12 : 6}>
                  <Controller
                    name="eventCity"
                    control={control}
                    rules={{
                      required: 'Event city is required',
                      validate: (value) => !htmlRegex.test(value) || 'HTML tags are not allowed'
                    }}
                    render={({ field }) => (
                      <FdTextField
                        {...field}
                        required
                        name="eventCity"
                        id="eventCity"
                        label="City"
                        InputProps={{
                          sx: classes.textFieldWithAdornment,
                          endAdornment: (
                            <InputAdornment position="end" sx={classes.inputIcon}>
                              <MdLocationOn />
                            </InputAdornment>
                          ),
                        }}
                        error={!!errors.eventCity}
                        errorMsg={errors.eventCity ? errors.eventCity.message : ''}
                      />
                    )} />
                </Grid>
                <Grid item xs={!isEventInfo ? 12 : 6}>
                  <Controller
                    name="eventLocation"
                    control={control}
                    rules={{
                      required: 'Event location is required',
                      validate: (value) => !htmlRegex.test(value) || 'HTML tags are not allowed'
                    }}
                    render={({ field }) => (
                      <FdTextField
                        {...field}
                        required
                        name="eventLocation"
                        id="eventLocation"
                        label="Location"
                        InputProps={{
                          sx: classes.textFieldWithAdornment,
                          endAdornment: (
                            <InputAdornment position="end" sx={classes.inputIcon}>
                              <MdLocationOn />
                            </InputAdornment>
                          ),
                        }}
                        error={!!errors.eventLocation}
                        errorMsg={errors.eventLocation ? errors.eventLocation.message : ''}
                      />)} />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={!isEventInfo ? 12 : 6}>
              <Controller
                control={control}
                name="eventTimezone"
                rules={
                  {
                    required: true,
                    // validate: {
                    //   eventTimezone: (tz) => {
                    //     return tz.length === 0 && <p>enter timezone</p>;
                    //   }

                    // },
                  }}
                render={({ field: { onChange, value, } }) => (
                  <>
                    <FdAutoComplete
                      // {...field}
                      options={timezoneLabels}
                      renderInput={(params) => {
                        return (
                          <FdTextField
                            {...params}
                            required
                            register={register}
                            name="eventTimezone"
                            margin="normal"
                            onChange={onChange}
                            label="Timezone"
                            error={!!errors.eventTimezone}
                            errorMsg={errors.eventTimezone && "Event Timezone is required"}
                          />
                        );
                      }}
                      disableClearable
                      onChange={(event, values, reason) => onChange(values)}
                      value={value}
                    />
                  </>
                )}
              />
            </Grid>
            <Grid item xs={!isEventInfo ? 12 : 6}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <Controller
                    {...register("eventStartDate")}
                    control={control}
                    defaultValue={new Date(selectedEvent?.startDateTime)}
                    render={({ field: { onBlur, name, ...field } }) => (
                      <>
                        <DateTimePicker
                          label="Start date"
                          {...field}
                          // inputRef={ref}
                          format="yyyy.MM.dd, HH:mm"
                          ampm={false}
                          disablePast={disablePast}
                          sx={customStyle}
                          className={disablePast ? "noPastErrorStyle" : ''}
                          slotProps={{
                            textField: {
                              helperText: errors?.eventStartDate?.message,
                              error: errors.eventStartDate,
                            },
                          }}
                        />
                      </>
                    )}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Controller
                    {...register("eventEndDate")}
                    control={control}
                    defaultValue={new Date(selectedEvent?.endDateTime)}
                    rules={{
                      validate: {
                        eventEndDate: (date) =>
                          date > getValues("eventStartDate") ||
                          "Event end date should be less than event start date",
                      },
                    }}
                    render={({ field: { onBlur, name, ...field } }) => (
                      <>
                        <DateTimePicker
                          label="End date"
                          {...field}
                          // inputRef={ref}
                          format="yyyy.MM.dd, HH:mm"
                          ampm={false}
                          disablePast={disablePast}
                          className={disablePast ? "noPastErrorStyle" : ''}
                          slotProps={{
                            textField: {
                              helperText: errors?.eventEndDate?.message,
                              error: errors.eventEndDate,
                            },
                          }}
                          sx={customStyle}
                        />
                      </>
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={!isEventInfo ? 12 : 6}>
              <FdTextField
                required
                type="number"
                register={register}
                name="eventArchiveInterval"
                id="eventArchiveInterval"
                label={
                  <LabelWithTooltip
                    label="Days before archiving"
                    hint="The event will be automatically archived after this amount of days after the event end-date."
                  />
                }
                InputProps={{
                  sx: classes.textField,
                }}
                error={errors.eventArchiveInterval}
                errorMsg={errors.eventArchiveInterval && "This field is required"}
              />
            </Grid>
            <Grid item xs={6}>
              {isEventInfo && <FdTextField
                register={register}
                name="singleAttendeeSyncUrl"
                id="singleAttendeeSyncUrl"
                label="Single Attendee sync url"
                placeholder=""
                InputProps={{
                  sx: classes.textField,
                }}
              />}
            </Grid>
            <Grid item xs={!isEventInfo ? 12 : 6}>
              <FdSwitch
                register={register}
                name="autoSwitchSession"
                label={
                  <>
                    <FdTypography label="Auto switch session" component="h3" variant="body1" sx={{ fontWeight: "bold", }} />
                    <FdTypography label="Allow auto-switching of sessions based on time and location." component="p" />
                  </>
                }
                placement="start"
                defaultChecked={selectedEvent?.autoSwitchSession}
              />
            </Grid>
            <Grid item xs={!isEventInfo ? 12 : 6}>
              <FdSwitch
                register={register}
                name="hasFraudDetection"
                label={
                  <>
                    <FdTypography label="Enable fraud detection" component="h3" variant="body1" sx={{ fontWeight: "bold", }} />
                  </>
                }
                placement="start"
                defaultChecked={Boolean(selectedEvent?.hasFraudDetection)}

              />
            </Grid>
            {(isEventInfo && canManageLeads) &&
              <Grid item xs={12}>
                <Controller
                  {...register("leadRetrieval")}
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <FdSwitch
                      register={register}
                      name="leadRetrieval"
                      label={
                        <>
                          <FdTypography label="Lead retrieval" component="h3" variant="body1" sx={{ fontWeight: "bold", }} />
                          <FdTypography label="Enable lead retrieval for this event" component="p" />
                        </>
                      }
                      placement="start"
                      onChange={(e) => onChange(e.target.checked)}
                      checked={value}
                    />
                  )
                  }
                />
              </Grid>
            }
          </Grid>
        </Box>
      </Box>
    </>
  );
};
